import React from 'react'
import './CollectionAsset.css'
import { Link } from "react-router-dom"
import FavoriteBorderIcon from '@material-ui/icons/FavoriteBorder';
import FavoriteIcon from '@material-ui/icons/Favorite';

function CollectionAsset({ ImageThumb, Price, Like }) {
    return (
        <div className="CollectionAssetItem">
            <Link to="/user/username/asset/">
            <img src={ImageThumb} alt="" className="CollectionAssetOpImg"/>
            </Link>
            <span className="CollectionAssetOpData">
                <span className="CollEData">${Price} ETH</span>
                <span className="CollEData"><FavoriteBorderIcon /> {Like}</span>
            </span>
        </div>
    )
}

export default CollectionAsset
